'use es6';

import { List } from 'immutable';
import { getDimensions } from '../utils/column-utils';

/**
 * Given a `Dataset` (which might have a mixed level-of-detail), returns a new
 * `Dataset` "grouped by" the fields representing the desired level-of-detail,
 * and trims the excess fields
 *
 * @param {List<string>} groupByFields - fields to group by
 * @param {List<string>} aggregateFields - fields to aggregate
 * @param {Dataset} dataset
 * @returns {Dataset}
 */
export const fixLOD = (groupByFields, aggregateFields, dataset) => {
  const allFields = groupByFields.concat(aggregateFields);
  const selectGroupByValues = row => groupByFields.map(field => row.get(field));
  const trimProperties = properties => properties.filter((_, field) => allFields.includes(field));
  const trimRow = row => row.filter((_, field) => allFields.includes(field));
  return dataset.update('data', data => data.groupBy(selectGroupByValues).toList().flatMap(rows => List.of(rows.first())).map(trimRow)).update('properties', trimProperties);
};

/**
 * @param {RelationalReport} report
 * @param {string} measureId
 * @returns {List<string>} fixed ids
 */
export const deriveFixedIds = (report, measureId) => {
  const columns = report.columns;
  const maybeMeasure = columns.get(measureId);
  const isFixed = maybeMeasure && maybeMeasure.fixedMeasure;
  return isFixed ? maybeMeasure.fixed || List() : getDimensions(columns).map(c => c.alias);
};